module.exports = __webpack_public_path__ + "img/Slice 268@2x(6).73adbfb9.png";